module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select3.09e84038.png";